export default "__VITE_ASSET__Dlw_1ke$__"